import { MapMarkerUpIcon } from './MapMarkerUpIcon';

/**
 * author: François Risoud
 * id 0C1B9015-C0F4-4710-87D2-BA7B710943F2
 * name map-marker-up
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-up.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationUpIcon = MapMarkerUpIcon;
export default LocationUpIcon